module.exports = __webpack_public_path__ + "img/64.8.TSS.37afb343.png";